import { render, staticRenderFns } from "./CopyProcessedRelatedPartsResultModal.vue?vue&type=template&id=8785cb7e&"
import script from "./CopyProcessedRelatedPartsResultModal.vue?vue&type=script&lang=ts&"
export * from "./CopyProcessedRelatedPartsResultModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports